import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Modal,
  styled,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import DoneIcon from "@mui/icons-material/Done";

const modalStyle = {
  position: "absolute",
  top: "50%",
  right: 0,
  transform: "translateY(-50%)",
  width: 450,
  maxHeight: "100vh",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  p: 3,
  overflowY: "hidden",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#ffffff",
  borderRadius: "8px",
};

const TitleContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  position: "relative",
  marginBottom: theme.spacing(3),
  paddingTop: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(1),
}));

const TodoModalDetail: React.FC<any> = ({
  open,
  close,
  todoDetail,
  owner,
  person,
  context,
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [title, setTitle] = useState(
    todoDetail?.title || "Remplir les compétences"
  );
  const [description, setDescription] = useState(
    todoDetail?.description ||
      "Faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche Faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche Faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche Faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche Faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche Faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche Faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâcheFaire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche Faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche pour faire cette tâche "
  );

  const handleEditToggle = () => {
    setIsEditable(!isEditable);
  };

  const handleClose = () => {
    close();
    setIsEditable(false);
  };

  const handleDelete = () => {
    // Implement delete functionality here
  };

  const handleConfirmEdit = () => {
    // Implement confirm edit functionality here
    setIsEditable(false);
  };

  const { t } = useTranslation("common");
  const theme = useTheme();

  return (
    <Modal open={open} onClose={handleClose} hideBackdrop>
      <Card
        sx={{
          ...modalStyle,
          height: "100%",
          boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Box>
          <TitleContainer>
            <Typography
              variant="subtitle1"
              fontWeight={500}
              color="text.primary"
            >
              {context === "benef"
                ? t("todo.title_benef_" + owner)
                : owner === "benef" || owner === "company"
                ? t("todo.todo_for") + " " + person?.fullName
                : owner === "advisor"
                ? t("todo.todo_for_advisor")
                : null}
            </Typography>
            <Box
              sx={{
                height: 40,
                width: 40,
                backgroundColor: "#e0e0e0",
                borderRadius: "50%",
                position: "absolute",
                top: "50%",
                right: 0,
                transform: "translateY(-50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "background-color 0.3s",
                "&:hover": {
                  backgroundColor: "#d6d6d6",
                },
              }}
            >
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </TitleContainer>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
          >
            {isEditable ? (
              <TextField
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                fullWidth
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              />
            ) : (
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                color="text.primary"
              >
                {title}
              </Typography>
            )}
            {owner === context && (
              <Box display="flex" gap={1}>
                {isEditable ? (
                  <>
                    <IconButton onClick={handleConfirmEdit} color="primary">
                      <DoneIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => setIsEditable(false)}
                      color="error"
                    >
                      <CloseIcon />
                    </IconButton>
                  </>
                ) : (
                  <>
                    <IconButton onClick={handleEditToggle} color="primary">
                      <BorderColorIcon />
                    </IconButton>
                    <IconButton onClick={handleDelete} color="error">
                      <DeleteIcon />
                    </IconButton>
                  </>
                )}
              </Box>
            )}
          </Box>

          <Card
            sx={{
              marginBottom: 2,
              boxShadow: "none",
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: "8px",
            }}
          >
            <CardContent>
              {isEditable ? (
                <TextField
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  fullWidth
                  multiline
                  variant="outlined"
                  InputProps={{
                    style: { overflow: "hidden" },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      padding: "8px",
                      borderRadius: "8px",
                    },
                  }}
                />
              ) : (
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {description}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Box>
      </Card>
    </Modal>
  );
};

export default TodoModalDetail;
